import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './authProvider';

export function RoleRoute({ allowedRoles }) {
  const auth = useAuth();
  
  // Define role hierarchy: admin can access all routes, teacher can access teacher routes, student only student routes
  const hasAccess = () => {
    const userRole = auth.user?.role;
    
    if (userRole === 'admin') {
      // Admin can access admin and teacher routes
      return allowedRoles.includes('admin') || allowedRoles.includes('teacher');
    } else if (userRole === 'teacher') {
      // Teacher can only access teacher routes
      return allowedRoles.includes('teacher');
    } else if (userRole === 'student') {
      // Student can only access student routes
      return allowedRoles.includes('student');
    }
    
    return false;
  };

  if (!hasAccess()) {
    // Redirect to appropriate route based on user role
    const userRole = auth.user?.role;
    if (userRole === 'admin') {
      return <Navigate to="/teacher" replace />;
    } else if (userRole === 'teacher') {
      return <Navigate to="/teacher" replace />;
    } else if (userRole === 'student') {
      return <Navigate to="/student" replace />;
    } else {
      return <Navigate to="/auth" replace />;
    }
  }
  
  return <Outlet />;
}